import { createAction, props } from '@ngrx/store';
import { TokenAuthOptions } from '@panamax/app-state';

//action for successful session auth
export const NewSession = createAction(
  '[Platform] New Session',
  props<{ options?: TokenAuthOptions }>(),
);
